const { DateTime } = require('luxon');
const { isNil } = require('ramda');

export function isMorning(dateTime) {
  return dateTime.toUTC().hour < 6;
}

export function toLocaleTH(dateTime) {
  const isBuddhistCalendar = dateTime.year > 2500;

  if (isBuddhistCalendar) {
    return dateTime.setZone("utc+7").setLocale("th");
  }

  return dateTime
    .setZone("utc+7")
    .setLocale("th")
    .reconfigure({ outputCalendar: "buddhist" });
}

const THAI_SHORT_MONTHS = [
  "ม.ค.",
  "ก.พ.",
  "มี.ค.",
  "เม.ย.",
  "พ.ค.",
  "มิ.ย.",
  "ก.ค.",
  "ส.ค.",
  "ก.ย.",
  "ต.ค.",
  "พ.ย.",
  "ธ.ค.",
];

export function toDateTime(date) {
  if (!date) return null;

  if (DateTime.isDateTime(date)) return date;

  if (date instanceof Date) {
    return DateTime.fromJSDate(date);
  }

  if (typeof date === "string") {
    const dateTime = DateTime.fromISO(date);

    return dateTime.isValid
      ? dateTime
      : DateTime.fromSQL(date);
  }

  return null;
}

export function formatThaiShortBuddhistDate(date) {
  if (!date) return null;

  const dateTime = toDateTime(date);

  if (!dateTime) return String(date);

  const localizedDateTime = toLocaleTH(dateTime);

  if (!localizedDateTime.isValid) return String(date);

  const buddhistYear =
    localizedDateTime.year > 2500
      ? localizedDateTime.year
      : localizedDateTime.year + 543;
  const shortYear = String(buddhistYear).slice(-2);

  return `${localizedDateTime.day} ${
    THAI_SHORT_MONTHS[localizedDateTime.month - 1]
  } ${shortYear}`;
}

export function formatThaiShortBuddhistDateRange(startAt, endAt) {
  const formattedStartAt = formatThaiShortBuddhistDate(startAt);
  const formattedEndAt = formatThaiShortBuddhistDate(endAt);

  if (formattedStartAt && formattedEndAt) {
    return `${formattedStartAt} - ${formattedEndAt}`;
  }

  return formattedStartAt || formattedEndAt;
}

export function getAppointmentTimeText(dateTime) {
  return isMorning(dateTime)
    ? "ช่วงเช้า (09:00 - 12:00 น.)"
    : "ช่วงบ่าย (13:00 - 16:00 น.)";
}

export function getDurationAppointmentTimeText(dateTimeStart, dateTimeEnd) {
  const ISOdateTime = dateTimeStart
    ? DateTime.fromISO(dateTimeStart)
    : null;

  const ISOdateTimeEnd = dateTimeEnd
    ? DateTime.fromISO(dateTimeEnd)
    : null;

  const dateTimeStartFormat = ISOdateTime
    ? toLocaleTH(ISOdateTime).toFormat("HH:mm")
    : null;
  const dateTimeStartEnd = ISOdateTimeEnd
    ? toLocaleTH(ISOdateTimeEnd).toFormat("HH:mm")
    : null;

  let time = ''
  if (dateTimeStartFormat && dateTimeStartEnd) {
    time = `(${dateTimeStartFormat} - ${dateTimeStartEnd} น.)`
  } else if (dateTimeStartFormat) {
    time = `(${dateTimeStartFormat} น.)`
  }

  return time
}

export function convertDateTimeToTimeText(dateTimeStart, format = "dd MMM yyyy HH:mm น.") {
  const ISOdateTime = dateTimeStart
    ? DateTime.fromISO(dateTimeStart)
    : null;

  return ISOdateTime
    ? toLocaleTH(ISOdateTime).toFormat(format)
    : '';
}

export function toOptionalDateTime(optionalISOString) {
  if (isNil(optionalISOString)) return undefined;

  return DateTime.fromISO(optionalISOString);
}

export function toOptionalISOString(optionalDateTime) {
  if (isNil(optionalDateTime)) return undefined;

  return optionalDateTime.toISO();
}

export function fromJSDateToOptionalISODate(OptionalDateTime) {
  const isoDate = OptionalDateTime
    ? DateTime.fromJSDate(OptionalDateTime).toUTC().toISO()
    : null;

  return isoDate;
}

export function formatOrFallbackToInput(date, format) {
  if (DateTime.fromISO(date).isValid) {
    return toLocaleTH(
      DateTime.fromISO(date)
    ).toFormat(format);
  }
  
  return date;
}

/**
 * @param {DateTime} from
 * @param {DateTime} to
 * @param {Number} [limit=31]
 * @returns {boolean}
 */
export const validateDateRangeLimit = (
  from, to, limit = 31
) => {
  if (!from || !to) return false;

  const parsedFrom = typeof from === 'string' ? DateTime.fromISO(from) : from;
  const parsedTo = typeof to === 'string' ? DateTime.fromISO(to) : to;

  return parsedTo.diff(parsedFrom, 'days').days > limit;
}
